import { ChevronRight } from "lucide-react";
import { getGuidesForService } from "../data/service-guides";

/** Compact internal-link strip pointing a service or city page at its guides. */
export function GuideStrip({
  serviceSlug,
  serviceName,
}: {
  serviceSlug: string;
  serviceName: string;
}) {
  const guides = getGuidesForService(serviceSlug, serviceName);
  if (guides.length === 0) return null;

  return (
    <section className="bg-[var(--brand-light-gray)] py-12 md:py-14 border-t border-gray-200">
      <div className="mx-auto max-w-[1100px] px-4">
        <div className="text-center mb-6">
          <p
            className="text-[var(--brand-red)] font-semibold uppercase tracking-[0.2em] text-sm mb-2"
            style={{ fontFamily: "var(--font-display)" }}
          >
            Homeowner Guides
          </p>
          <h2
            className="text-[var(--brand-deep-blue)] text-2xl md:text-3xl uppercase leading-tight"
            style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
          >
            Learn Before You Book
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {guides.map((g) => (
            <a
              key={g.slug}
              href={`/guides/${g.slug}`}
              className="group rounded-md border border-[var(--brand-deep-blue)]/10 bg-white p-5 hover:border-[var(--brand-bright-blue)] hover:shadow-md transition-all"
            >
              <span className="flex items-start justify-between gap-2">
                <span className="text-[15px] font-semibold text-[var(--brand-charcoal)] group-hover:text-[var(--brand-bright-blue)] transition-colors">
                  {g.title}
                </span>
                <ChevronRight size={16} className="text-[var(--brand-charcoal)]/40 shrink-0 mt-1" />
              </span>
              <p className="mt-2 text-sm leading-relaxed text-[var(--brand-charcoal)]/75">
                {g.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}